<template>
    <div class="tabs p-5">
        <div class="border rounded-md border-gray-300 shadow-sm pb-2">
            <div class="tab-nav flex justify-between items-center w-full px-5 border-b justify">
                <h2 class="font-bold text-blue-500 text-xl flex items-center py-2.5">
                  <button @click="nextTo()" class="pr-2">
                      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-8 h-8">
                  <path fill-rule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25zm-4.28 9.22a.75.75 0 000 1.06l3 3a.75.75 0 101.06-1.06l-1.72-1.72h5.69a.75.75 0 000-1.5h-5.69l1.72-1.72a.75.75 0 00-1.06-1.06l-3 3z" clip-rule="evenodd" />
                  </svg>
                </button>
               Форма добавления пользователя
                    <!-- Форма добавления -->
                </h2>
            </div>
            <div class="tab-content border-0 px-7">
                <div class="rounded-b-md flex justify-between pt-4">
                   <div>
                       <label for="firstName" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Имя</label>
                       <input id="firstName" rows="4" class="rounded-md block p-2.5 w-[700px] text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 mb-2" placeholder="Введите имя..." v-model="this.user.firstName" />
                    </div>
                    <div>
                        <label for="lastName" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Фамилия</label>
                        <input id="lastName" rows="4" class="rounded-md block p-2.5 w-[700px] text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 mb-2" placeholder="Введите фамилия..." v-model="this.user.lastName" />
                    </div>
                </div>
               
                <div class="rounded-b-md flex justify-between pt-4">
                    <div>
                        <label for="phoneNumber" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Номер телефона</label>
                        <input id="phoneNumber" rows="4" class="rounded-md block p-2.5 w-[700px] text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 mb-2" placeholder="Введите телефон номер..." v-model="this.user.phoneNumber" />
                    </div>
                    <div>
                        <label for="email" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Email</label>
                        <input id="email" rows="4" class="rounded-md block p-2.5 w-[700px] text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 mb-2" placeholder="Введите почта..." v-model="this.user.email" />
                    </div>
                </div>
                <div class="rounded-b-md flex justify-between pt-4">
                    <div>
                        <label for="userName" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Имя пользователя (ROCKED)</label>
                        <input id="userName" rows="4" class="rounded-md block p-2.5 w-[700px] text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 mb-2" placeholder="Введите Username..." v-model="this.user.userName" v-bind:readonly="isReadOnly"/>
                    </div>
                    <div>
                        <label for="password" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Пароль</label>
                        <input id="password" rows="4" class="rounded-md block p-2.5 w-[700px] text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 mb-2" placeholder="Введите Password..." v-model="this.user.password" />
                    </div>
                </div>
                <div class="rounded-b-md flex justify-between pt-4">
                    <div>
                        <label for="confirmPassword" class="block mb-2 text-sm font-medium text-gray-900 dark:text-white">Подтвердите пароль</label>
                        <input id="confirmPassword" rows="4" class="rounded-md block p-2.5 w-[700px] text-sm text-gray-900 bg-gray-50 border border-gray-300 focus:ring-blue-500 focus:border-blue-500 mb-2" placeholder="Введите confirmPassword..." v-model="this.user.confirmPassword" v-bind:readonly="isReadOnly"/>
                    </div>
                </div>
            </div>
        </div>
        <div class="flex float-right mt-5 space-x-5">

            <div class="w-40">
                <button @click="clearForm()" class="rounded-md w-full text-white bg-gradient-to-r from-slate-500 via-gray-600 to-gray-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-slate-300 dark:focus:ring-gray-800 font-medium text-sm px-5 py-2.5 text-center">
                    Cancel
                </button>
            </div>
            <div class="w-40">
                <button v-show="visibleButtonFirst" @click="add()" class="rounded-md w-full text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium text-sm px-5 py-2.5 text-center">
                    Сохранить 
                </button>
                <button v-show="visibleButtonSecond" @click="update()" class="rounded-md w-full text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium text-sm px-5 py-2.5 text-center">
                    Обновить  
                </button>
            </div>
        </div>
    </div>
    </template>
    
    <script>
    import {
        toast
    } from "vue3-toastify";
    export default {
        beforeRouteLeave(to, from, next) {
            sessionStorage.removeItem('CURRENT_USER');
            next();
        },
        data() {
            return {
                user: {
                    id:0,
                    firstName:null,
                    lastName: null,
                    email: null,
                    phoneNumber: null,
                    password: null,
                    confirmPassword: null,
                    userName:null,
                },
                visibleButtonFirst: true,
                visibleButtonSecond: false,
                isReadOnly:false,
                tabs: ["На русском"]
            };
        },
        methods: {
            nextTo(){
                this.$router.push('/allUser')
            },
            clearForm() {
                this.user = {
                    id:0,
                    firstName:null,
                    lastName: null,
                    password: null,
                    confirmPassword: null,
                    email: null,
                    phoneNumber: null,
                    userName:null,
                };
                sessionStorage.removeItem('CURRENT_USER');
                sessionStorage.removeItem('CURRENT_USER_EDIT');
            },
            async add() {
                try {
                    const response = await this.axios.post(
                        "api/Admin/User/CreateUser",
                        this.user, {
                            headers: {
                                "Content-Type": "application/json",
                            },
                        }
                    );
                    if (response.status === 200) {
                        toast.success(this.user.lastName + ' ' + this.user.firstName + " успешно добавлена/изменен", {
                            position: "top-center",
                            transition: "flip",
                            newestOnTop: true,
                            toastStyle: {
                                fontSize: "14px",
                            },
                        });
                        this.clearForm();
                        this.$router.push('/allUser')
                    }
                } catch (error) {
                    toast.error("Ошибка при добавлении/изменении - " + this.user.lastName + ' ' + this.user.firstName, {
                        position: "top-center",
                        transition: "flip",
                        newestOnTop: true,
                        toastStyle: {
                            fontSize: "14px",
                        },
                    });
                }
            },
            async update() {
                try {
                    const response = await this.axios.post(
                        "api/Admin/User/ChangeUser",
                        this.user, {
                            headers: {
                                "Content-Type": "application/json",
                            },
                        }
                    );
                    if (response.status === 200) {
                        toast.success(this.user.lastName + ' ' + this.user.firstName + " успешно добавлена/изменен", {
                            position: "top-center",
                            transition: "flip",
                            newestOnTop: true,
                            toastStyle: {
                                fontSize: "14px",
                            },
                        });
                        this.clearForm();
                        this.$router.push('/allUser')
                    }
                } catch (error) {
                    toast.error("Ошибка при добавлении/изменении - " + this.user.lastName + ' ' + this.user.firstName, {
                        position: "top-center",
                        transition: "flip",
                        newestOnTop: true,
                        toastStyle: {
                            fontSize: "14px",
                        },
                    });
                }
            },
        },
        mounted() {

            if (sessionStorage.getItem("CURRENT_USER")) {
                this.user = JSON.parse(sessionStorage.getItem("CURRENT_USER"));
                this.isReadOnly = true;
            }
            if(sessionStorage.getItem("CURRENT_USER_EDIT")){
                
                this.user = JSON.parse(sessionStorage.getItem("CURRENT_USER_EDIT"));
                this.isReadOnly = true;
                this.visibleButtonFirst = false;
                this.visibleButtonSecond = true;
            }
        },
    };
    </script>